import { Helmet } from 'react-helmet-async';
import { siteUrl } from '../lib/siteUrl';

const BRAND = 'ComfortTool™';

function withBrandInTitle(title: string): string {
  if (title.includes('ComfortTool™')) return title;
  if (title.includes('ComfortTool')) {
    return title.replace(/\bComfortTool\b/g, 'ComfortTool™');
  }
  return `${title} · ${BRAND}`;
}

type Props = {
  title: string;
  description?: string;
  /** Comma-gescheiden keywords (optioneel) */
  keywords?: string;
  /** Pad zoals /faq — voor canonical en og:url */
  path?: string;
  noindex?: boolean;
  /** Kennisbank / blog: Open Graph als artikel + juiste type voor zoekmachines */
  articlePublishedTime?: string;
};

export function Seo({ title, description, keywords, path, noindex, articlePublishedTime }: Props) {
  const fullTitle = withBrandInTitle(title);
  const base = siteUrl();
  const canonical =
    path !== undefined ? `${base}${path.startsWith('/') ? path : `/${path}`}` : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:type" content={articlePublishedTime ? 'article' : 'website'} />
      {articlePublishedTime ? (
        <meta property="article:published_time" content={articlePublishedTime} />
      ) : null}
      <meta property="og:locale" content="nl_NL" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
    </Helmet>
  );
}
